import { useCallback, useState } from 'react'

export default <TItem>() => {
  const [anchorEl, setAnchorEl] = useState<Element | null>(null)
  const [item, setItem] = useState<TItem | null>(null)
  const [open, setOpen] = useState(false)

  const onOpen = useCallback(({ anchor, item: selectedItem }: { anchor: Element; item: TItem }) => {
    setItem(selectedItem)
    setAnchorEl(anchor)
    setOpen(true)
  }, [])

  const onClose = useCallback(() => {
    setOpen(false)
  }, [])

  return { anchorEl, item, open, onOpen, onClose }
}
